<template>
  <div class="flex">
<!--    <div class="card-list">
      <div class="text-center margin-bottom">图文列表</div>
      <div
        class="img-text-card-item"
        v-for="(item,index) in articles"
        :class="{'selected':selectedIndex == index}"
        :key="index"
        @click="selectedIndex = index"
      >
        <div class="text-cut-name">{{item.title}}</div>
        <div class="delete-box"
             v-if="articles.length > 1"
          @click.stop="deleteHandle(index)"
        >
          <i class="el-icon-delete"></i>
        </div>
      </div>
      <div
        v-show="articles.length < 8 && !mediaId"
        class="card-add el-icon-plus"
        @click="addArticle()"
      ></div>
    </div>-->
    <el-form
      size="mini"
      v-if="articles.length"
      :model="articles[selectedIndex]"
      :rules="dataRule"
      ref="dataForm"
      :label-position="labelPosition"
      label-width="100px"
    >
      <el-form-item
        label="标题"
        prop="title"
      >
        <el-input
          v-model="articles[selectedIndex].title"
          placeholder="标题"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="封面图"
        prop="thumbMediaId"
      >
        <el-input
          v-model="articles[selectedIndex].thumbMediaId"
          placeholder="封面图media_id"
        >
          <div
            class="pointer"
            slot="append"
            @click="dialogShow=true"
          >从素材库中选择</div>
        </el-input>
      </el-form-item>
      <el-form-item label="摘要" prop="digest">
        <el-input v-model="articles[selectedIndex].digest" placeholder="摘要"></el-input>
      </el-form-item>
      <el-form-item
        label="原文地址"
        prop="contentSourceUrl">
        <el-input
          v-model="articles[selectedIndex].contentSourceUrl"
          placeholder="阅读原文链接"
        ></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="9">
          <el-form-item label="作者" prop="author">
            <el-input v-model="articles[selectedIndex].author" placeholder="作者"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="显示封面" prop="showCoverPic">
            <el-switch v-model="articles[selectedIndex].showCoverPic"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="允许评论" prop="needOpenComment">
            <el-switch v-model="articles[selectedIndex].needOpenComment"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="仅粉丝可评论" prop="onlyFansCanComment">
            <el-switch v-model="articles[selectedIndex].onlyFansCanComment"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="内容" prop="content">
        <quill-editor
          ref="editor"
          :defaultValues="articles[selectedIndex].content"
          @catchData="catchData"
        ></quill-editor>
      </el-form-item>
    </el-form>
    <metarial-img-dialog
      select-type="image"
      :dialog-show="dialogShow"
      @selected="onAssetsSelect"
      @close="closeHandle"
    ></metarial-img-dialog>
  </div>
</template>

<script>
import metarialImgDialog from "./metarialImgDialog";
import quillEditor from "@/components/public/quillEditor";
const articleTemplate={
  templateId: 0,
  title: '',
  content: '',
  author: '',
  showCoverPic: true,
  contentSourceUrl: '',
  digest: '',
  thumbMediaId: '',
  needOpenComment: false,
  onlyFansCanComment: false
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "imgTextContent",
  components: {
    quillEditor,
    metarialImgDialog,
  },
  data() {
    return {
      dialogShow:false,
      mediaId:'',
      selectedIndex:0,
      articles:[],
      uploading:false,
      dataRule: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不能为空', trigger: 'blur' }
        ],
        thumbMediaId: [
          { required: true, message: '封面图media_id不能为空', trigger: 'change' }
        ],
        contentSourceUrl: [
          { required: true, message: '原文地址不得为空', trigger: 'blur' }
        ]
      }
    }
  },
  mixins: [formLabalPosition],
  methods: {
    init(news){
      if(news && news.mediaId){
        this.mediaId = news.mediaId
        this.articles = news.content.newsItem
      }else{
        this.mediaId=''
        this.articles=[{...articleTemplate}]
      }
    },
    selfClear(){
      this.$refs.dataForm && this.$refs.dataForm.clearValidate();
      this.$refs.dataForm && this.$refs.dataForm.resetFields();
      this.init();
    },
    deleteHandle(index){
      if(this.articles.length == 1){
        this.$message.error('只有一个不能删除')
      }else {
        this.articles.splice(index,1);
        if(this.articles.length >= 1 && this.selectedIndex == index){
          this.selectedIndex = this.selectedIndex - 1;
        }
      }
    },
    selfValidate(){
      this.dataFormSubmit();
    },
    // 表单提交
    dataFormSubmit() {
      if(this.uploading)return
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if(this.mediaId){// 编辑，只能一次修改一篇
            this.materialArticleUpdate();
          }else{ // 新增，全部文章一起保存
            this.materialNewsUpload();
          }
        }
      })
    },
    handleParams(articles){
      let copyArticles =  JSON.parse(JSON.stringify(articles));
      for (let i = 0; i < copyArticles.length; i++) {
        copyArticles[i].showCoverPic == true ? copyArticles[i].showCoverPic = 1: copyArticles[i].showCoverPic = 0;
        copyArticles[i].needOpenComment == true ? copyArticles[i].needOpenComment = 1: copyArticles[i].needOpenComment = 0;
        copyArticles[i].onlyFansCanComment == true ? copyArticles[i].onlyFansCanComment = 1: copyArticles[i].onlyFansCanComment = 0;
      }
      return copyArticles;
    },
    handleUpdateParams(){
      let copyOne = JSON.parse(JSON.stringify(this.articles[this.selectedIndex]));
      for (const key in copyOne) {
        if(key == 'showCoverPic' || key == 'needOpenComment' || key == 'onlyFansCanComment'){
          copyOne[key] == true ? copyOne[key] = 1 : copyOne[key] = 0;
        }
      }
      return copyOne;
    },
    materialNewsUpload(){
      this.uploading=true
      this.$http({
        url: `/wx/manage/wxAssets/materialNewsUpload`,
        method: 'post',
        data: this.handleParams(this.articles),
      }).then((data) => {
        if (data.code === 200) {
          this.$message({
            message: "操作成功",
            type: "success",
            duration: 1500,
          });
          this.$emit("add-success");
        } else {
          this.$message.error(data.msg)
        }
        this.uploading=false
      })
    },
    materialArticleUpdate(){
      this.uploading = true;
      this.$http({
        url: `/wx/manage/wxAssets/materialArticleUpdate`,
        method: 'post',
        data: {
          'mediaId':this.mediaId,
          'index':this.selectedIndex,
          'articles': this.handleUpdateParams()
        }
      }).then((data) => {
        if (data.code === 200) {
          this.$emit('edit-success');
          this.$message.success('操作成功')
        } else {
          this.$message.error(data.msg)
        }
        this.uploading = false;
      })
    },
    addArticle(){
      this.articles.push({...articleTemplate})
      this.selectedIndex=this.articles.length-1
    },
    onAssetsSelect(assetsInfo){
      this.$set(this.articles[this.selectedIndex], 'thumbMediaId', assetsInfo.mediaId);
      this.dialogShow = false;
    },
    closeHandle(){
      this.dialogShow = false;
    },
    catchData(content){
      this.articles[this.selectedIndex].content = content;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variable";
.card-list{
  width: 300px;
  padding-right: 10px;
  border-right: 1px solid #eeeeee;
  .img-text-card-item{
    margin-top: 2px;
    padding: 20px 5px;
    border: 1px solid #ddd;
    font-size: 12px;
    line-height: 15px;
    position: relative;
    margin-bottom: 20px;
    .delete-box {
      position: absolute;
      z-index: 99;
      right: -10px;
      bottom: -5px;
      cursor: pointer;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #B7B8C9;
      display: none;
      &:hover {
        color: $themeColor;
      }
    }
    &:hover {
      .delete-box {
        display: block;
      }
    }
  }
  .img-text-card-item.selected{
    border: 2px solid #409EFF;
  }
  .text-cut-name{
    display: -webkit-box;
    word-wrap:break-word;
    word-break:break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .card-add{
    margin-top: 2px;
    display: block;
    border: 1px dotted #ddd;
    color: #ddd;
    text-align: center;
    font-size: 30px;
    line-height: 50px;
  }
  .dialog-footer {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
